import {TruncatePipe} from './pipe/truncate-pipe';
import {ToadMensagemService} from './../service/toad-mensagem.service';
import {MessageService} from 'primeng/components/common/messageservice';
import {FtaService} from './../service/fta.service';
import {PesquisasFiltroApiService} from './../service/api/pesquisas-filtro.api';
import {GlobalService} from './../service/global.service';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {AppRoutingModule} from './app-routing.module';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {CookieModule} from 'ngx-cookie';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgIdleKeepaliveModule} from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import {MyDatePickerModule} from 'mydatepicker';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {TokenInterceptor} from './auth/token-interceptor';
import {NotAuthorizedInterceptor} from './auth/not-authorized-interceptor';

/* PrimeNG */
import {InputTextModule} from 'primeng/components/inputtext/inputtext';
import {FieldsetModule} from 'primeng/components/fieldset/fieldset';
import {InputTextareaModule} from 'primeng/components/inputtextarea/inputtextarea';
import {ButtonModule} from 'primeng/components/button/button';
import {DropdownModule} from 'primeng/components/dropdown/dropdown';
import {PanelModule} from 'primeng/components/panel/panel';
import {SplitButtonModule} from 'primeng/components/splitbutton/splitbutton';
import {DialogModule} from 'primeng/components/dialog/dialog';
import {TooltipModule} from 'primeng/components/tooltip/tooltip';
import {CalendarModule} from 'primeng/components/calendar/calendar';
import {TabViewModule} from 'primeng/components/tabview/tabview';
import {InputMaskModule} from 'primeng/components/inputmask/inputmask';
import {ProgressBarModule} from 'primeng/components/progressbar/progressbar';
import {ToastModule} from 'primeng/toast';
import {CheckboxModule} from 'primeng/components/checkbox/checkbox';
import {MultiSelectModule} from 'primeng/components/multiselect/multiselect';
import {MessagesModule} from 'primeng/components/messages/messages';
import {MessageModule} from 'primeng/components/message/message';
import {ListboxModule} from 'primeng/components/listbox/listbox';

import {PickListModule} from 'primeng/components/picklist/picklist';
import {CardModule} from 'primeng/components/card/card';
import {TableModule} from 'primeng/components/table/table';
import {KeyFilterModule} from 'primeng/components/keyfilter/keyfilter';

import {ServiceModule} from '../service/service.module';
import {ModalModule} from './modal/modal.module';
import {ArtefatoModule} from './artefato/artefato.module';

/* Components Customizados*/
import {ArchwizardModule} from 'angular-archwizard';

/* Components */
import {AppComponent} from './app.component';
import {LoginComponent} from './login/login.component';
import {MenuComponent} from './menu/menu';
import {HomeComponent} from './home/home';
import {FluxoClienteInternoComponent} from './fluxo-cliente-interno/fluxo-cliente-interno';
import {FluxoClienteInternoCompletoComponent} from './fluxo-cliente-interno-completo/fluxo-cliente-interno-completo';
import {FluxoClienteExternoComponent} from './fluxo-cliente-externo/fluxo-cliente-externo';
import {ConsultaFluxosComponent} from './consulta-fluxos/consulta-fluxos';
import {CadastroEventoComponent} from './cadastro-evento/cadastro-evento.component';
import {
    CadastroJanelaPermissaoOcorrenciaComponent
} from './cadastro-janela-permissao-ocorrencia/cadastro-janela-permissao-ocorrencia.component';
import {CadastroScheduleExecucaoComponent} from './cadastro-schedule-execucao/cadastro-schedule-execucao.component';
import {
    DetalheEventoProcessamentoComponent
} from './detalhe-evento-processamento/detalhe-evento-processamento.component';
import {DetalheEventoOperacaoComponent} from './detalhe-evento-operacao/detalhe-evento-operacao.component';
import {DetalheEventoTransmissaoComponent} from './detalhe-evento-transmissao/detalhe-evento-transmissao.component';
import {DetalheEventoPermissoesComponent} from './detalhe-evento-permissoes/detalhe-evento-permissoes.component';
import {DetalheEventoParametrosComponent} from './detalhe-evento-parametros/detalhe-evento-parametros.component';


import {NavBarComponent} from './nav-bar/nav-bar.component';
import {EdicaoFtaComponent} from './edicao-fta/edicao-fta.component';
import {CadastroDependenciaComponent} from './cadastro-dependencia/cadastro-dependencia.component';
import {CatalogoComponent} from './catalogo/catalogo.component';
import {UsuarioComponent} from './usuario/usuario.component';
import {ArquivoSiaComponent} from './arquivo-sia/arquivo-sia.component';
import {UsuarioNovoComponent} from './usuario/usuario-novo/usuario-novo.component';
import {HomeArtefatoComponent} from './artefato/home-artefato/home-artefato.component';
import {PesquisaFluxoComponent} from './pesquisa-fluxo/pesquisa-fluxo.component';
import {DigitDecimaNumberDirectiveDirective} from './directive/input-decimal/digit-decima-number-directive.directive';
import { AvaliacaoApiService } from '../service/api/avaliacao.api';
// import {AvaliacaoModalComponent } from './modal/avaliacao-modal/avaliacao-modal.component';


@NgModule({
    imports: [
        BrowserModule,
        RouterModule,
        AppRoutingModule,
        HttpClientModule,
        CookieModule.forRoot(),
        NgIdleKeepaliveModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        ServiceModule,
        ModalModule,
        ArtefatoModule,
        MyDatePickerModule,
        BrowserAnimationsModule,
        InputTextModule,
        FieldsetModule,
        InputTextareaModule,
        ButtonModule,
        DropdownModule,
        PanelModule,
        SplitButtonModule,
        DialogModule,
        TooltipModule,
        CalendarModule,
        InputMaskModule,
        TabViewModule,
        ProgressBarModule,
        PickListModule,
        CardModule,
        TableModule,
        KeyFilterModule,
        ToastModule,
        CheckboxModule,
        TabViewModule,
        MultiSelectModule,
        ArchwizardModule,
        MessagesModule,
        MessageModule,
        ListboxModule

    ],
    declarations: [
        AppComponent,
        LoginComponent,
        MenuComponent,
        HomeComponent,
        // AvaliacaoModalComponent,
        FluxoClienteInternoComponent,
        FluxoClienteInternoCompletoComponent,
        FluxoClienteExternoComponent,
        ConsultaFluxosComponent,
        CadastroEventoComponent,
        CadastroJanelaPermissaoOcorrenciaComponent,
        CadastroScheduleExecucaoComponent,
        DetalheEventoProcessamentoComponent,
        DetalheEventoOperacaoComponent,
        DetalheEventoTransmissaoComponent,
        DetalheEventoPermissoesComponent,
        DetalheEventoParametrosComponent,
        NavBarComponent,
        EdicaoFtaComponent,
        CadastroDependenciaComponent,
        TruncatePipe,
        CatalogoComponent,
        UsuarioComponent,
        ArquivoSiaComponent,
        UsuarioNovoComponent,
        HomeArtefatoComponent,
        PesquisaFluxoComponent,
        DigitDecimaNumberDirectiveDirective
    ],
    providers: [
        {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: NotAuthorizedInterceptor, multi: true},
        {provide: GlobalService, useClass: GlobalService},
        {provide: FtaService, useClass: FtaService},
        {provide: MessageService, useClass: MessageService},
        {provide: ToadMensagemService, useClass: ToadMensagemService},
        {provide: PesquisasFiltroApiService, useClass: PesquisasFiltroApiService},
        { provide: AvaliacaoApiService, useClass: AvaliacaoApiService }
    ],

    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts